<template>
  <div class="top-menu">
    <Dropdown
      class="top-menu-dropdown"
      :icon="true"
      :info="header.GettyExplore"
      :title="title"
    />
    <HeaderTopNav :info="header.GettyTopLinks" />
    <HeaderTopForm :info="header.GettyTopSearch" />
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown";
import HeaderTopForm from "@/components/HeaderTopForm";
import HeaderTopNav from "@/components/HeaderTopNav";

export default {
  name: "HeaderTop",
  data() {
    return {
      title: "<strong>The Getty</strong>: Explore"
    };
  },
  components: {
    Dropdown,
    HeaderTopForm,
    HeaderTopNav
  },
  props: {
    header: Object
  }
};
</script>

<style lang="scss" scoped>
.top-menu {
  background: transparent;
  font-size: 0.75em;
  position: relative;
  z-index: 1;
  &-dropwn {
    border-radius: 0;
  }
}
</style>
